const e = "styles-module__hoverMenu___Ix9kX", t = "styles-module__scrolledHeader___xf9UT", _ = "styles-module__menuItem___uDn4w", n = "styles-module__menuItemText___7pErb", o = "styles-module__menuIcon___7m7ZG", s = "styles-module__buttonWrapper___t3J64", u = {
  hoverMenu: e,
  scrolledHeader: t,
  menuItem: _,
  menuItemText: n,
  menuIcon: o,
  buttonWrapper: s
};
export {
  s as buttonWrapper,
  u as default,
  e as hoverMenu,
  o as menuIcon,
  _ as menuItem,
  n as menuItemText,
  t as scrolledHeader
};
